import { render, staticRenderFns } from "./BrandingCombinationError.vue?vue&type=template&id=ef009f5c&scoped=true&"
import script from "./BrandingCombinationError.vue?vue&type=script&lang=js&"
export * from "./BrandingCombinationError.vue?vue&type=script&lang=js&"
import style0 from "./BrandingCombinationError.vue?vue&type=style&index=0&id=ef009f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef009f5c",
  null
  
)

export default component.exports